import { PUBLIC_ROUTES } from './constants';

export const isPublicRoute = (pathname: string): boolean => {
  // Check exact matches
  if (PUBLIC_ROUTES.exact.includes(pathname)) {
    return true;
  }

  // Check routes that use includes (like digital onboarding routes)
  return PUBLIC_ROUTES.includes.some(route => pathname.includes(route));
};
